/* NOSEKNOWS status-view (案A: 署名URLランディング)
   - URL の ?t=<token> を取得 → GET /apps/nk/status-link/verify
   - nk-member.js の STATE_LABELS / アクション導線ロジックと整合
   - Fragment は表示しない (非ログインなので簡易ビュー)
*/
(function () {
  "use strict";

  var VERIFY_ENDPOINT = "/apps/nk/status-link/verify";

  var STATE_LABELS = {
    LOCKED: "権限なし",
    PENALTY: "応募停止中",
    PURCHASED: "オーナー",
    ACTIVE: "購入可能",
    EXPIRED: "購入期限切れ",
    APPLIED: "応募済み",
    WAITLISTED: "招待待ち",
    NONE: "---"
  };

  var STATE_MESSAGES = {
    LOCKED: "このアカウントは一時的に利用停止中です。",
    PENALTY: "前回の当選分が購入されなかったため、一定期間応募ができません。",
    PURCHASED: "オーナーとして登録されています。",
    ACTIVE: "購入権は有効です。ログインして期限内にお進みください。",
    EXPIRED: "このDropの購入期限は終了しました。",
    APPLIED: "応募を受け付けました。結果をお待ちください。",
    WAITLISTED: "DROP公開の案内をお待ちください。",
    NONE: "応募履歴が見つかりません。"
  };

  function formatDateJP(iso) {
    if (!iso) return "---";
    var d = new Date(iso);
    if (isNaN(d.getTime())) return "---";
    var y = d.getFullYear();
    var m = d.getMonth() + 1;
    var day = d.getDate();
    var h = d.getHours();
    var mm = String(d.getMinutes()).padStart(2, "0");
    return y + "年" + m + "月" + day + "日 " + h + ":" + mm;
  }

  function formatRemaining(iso) {
    if (!iso) return "";
    var diff = new Date(iso).getTime() - Date.now();
    if (diff <= 0) return "期限切れ";
    var hours = Math.floor(diff / 3600000);
    var mins = Math.floor((diff % 3600000) / 60000);
    return "残り" + hours + "時間" + mins + "分";
  }

  function show(el) { if (el) el.style.display = ""; }
  function hide(el) { if (el) el.style.display = "none"; }
  function setText(id, text) {
    var el = document.getElementById(id);
    if (el) el.textContent = text;
  }

  function renderState(d) {
    var state = d.state || { kind: "NONE" };
    var kind = state.kind;

    // Drop情報 (APPLIED/EXPIRED/ACTIVE/PURCHASED のみ)
    var currentDropEl = document.getElementById("nk-current-drop");
    if (currentDropEl) {
      var cur = d.current_drop;
      var showDrop = cur && (
        kind === "APPLIED" || kind === "EXPIRED" ||
        kind === "ACTIVE" || kind === "PURCHASED"
      );
      if (showDrop) {
        var numLabel = cur.number != null
          ? "DROP:" + String(cur.number).padStart(2, "0")
          : "DROP:—";
        setText("nk-current-drop-number", numLabel);
        setText("nk-current-drop-title", (cur.title || "").toLowerCase());
        show(currentDropEl);
      } else {
        hide(currentDropEl);
      }
    }

    // マスク済みメール
    if (d.email) {
      var row = document.getElementById("nk-masked-email-row");
      setText("nk-masked-email", d.email);
      show(row);
    }

    // メインラベル
    setText("nk-state-label", STATE_LABELS[kind] || "---");

    var labelEl = document.getElementById("nk-state-label");
    if (labelEl) {
      labelEl.classList.remove("nk-skeleton");
      labelEl.style.color =
        kind === "ACTIVE" || kind === "PURCHASED"
          ? "var(--c1)"
          : kind === "LOCKED" || kind === "PENALTY"
            ? "var(--muted)"
            : "var(--fg)";
    }

    // メッセージ
    var msgEl = document.getElementById("nk-state-message");
    if (msgEl) {
      var msg = STATE_MESSAGES[kind] || "";
      if (msg) {
        msgEl.textContent = msg;
        show(msgEl);
      } else {
        hide(msgEl);
      }
    }

    // 日時行の表示制御
    hide(document.getElementById("nk-draw-at-row"));
    hide(document.getElementById("nk-purchase-expires-row"));
    hide(document.getElementById("nk-penalty-until-row"));

    if ((kind === "APPLIED" || kind === "WAITLISTED") && d.draw_at) {
      setText("nk-draw-at-value", formatDateJP(d.draw_at));
      show(document.getElementById("nk-draw-at-row"));
    }

    if (kind === "ACTIVE" && state.expiresAt) {
      setText(
        "nk-purchase-expires-value",
        formatDateJP(state.expiresAt) + "(" + formatRemaining(state.expiresAt) + ")"
      );
      show(document.getElementById("nk-purchase-expires-row"));
    }

    if (kind === "PENALTY" && (state.until || d.penalty_until)) {
      setText("nk-penalty-until-value", formatDateJP(state.until || d.penalty_until));
      show(document.getElementById("nk-penalty-until-row"));
    }

    // アクションボタン (ACTIVEはログインへ、APPLIEDは対象商品へ)
    var btnWrap = document.getElementById("nk-action-button-wrap");
    var btn = document.getElementById("nk-action-button");
    if (btn && btnWrap) {
      var handle = d.current_drop && d.current_drop.handle;
      var productUrl = handle ? "/products/" + handle : "/collections/drop";
      if (kind === "ACTIVE") {
        btn.textContent = "LOGIN / 購入へ";
        btn.href = "/account/login";
        show(btnWrap);
      } else if (kind === "APPLIED" && handle) {
        btn.textContent = "応募中のDROPを見る";
        btn.href = productUrl;
        show(btnWrap);
      } else {
        hide(btnWrap);
      }
    }
  }

  function renderError(code) {
    // スケルトン解除
    var labelEl = document.getElementById("nk-state-label");
    if (labelEl) {
      labelEl.classList.remove("nk-skeleton");
      labelEl.textContent = "---";
      labelEl.style.color = "var(--muted)";
    }

    var errBox = document.getElementById("nk-status-error");
    var errMsg = document.getElementById("nk-status-error-message");
    var messages = {
      "INVALID_TOKEN": "リンクが無効です。改めてご確認ください。",
      "EXPIRED": "リンクの有効期限(15分)が切れました。"
    };
    if (errMsg) errMsg.textContent = messages[code] || "リンクを検証できませんでした。";
    if (errBox) show(errBox);
  }

  function getToken() {
    try {
      var params = new URLSearchParams(window.location.search);
      return params.get("t");
    } catch (e) {
      return null;
    }
  }

  // --- 実行 ---
  var token = getToken();
  if (!token) {
    renderError("INVALID_TOKEN");
    document.body.setAttribute("data-nk-loaded", "true");
    return;
  }

  fetch(VERIFY_ENDPOINT + "?t=" + encodeURIComponent(token))
    .then(function (r) { return r.json(); })
    .then(function (d) {
      if (d && d.ok) {
        renderState(d);
      } else {
        renderError(d && d.error);
      }
    })
    .catch(function () {
      renderError("INVALID_TOKEN");
    })
    .finally(function () {
      document.body.setAttribute("data-nk-loaded", "true");
    });
})();
